<template>
  <button
    class="group grid w-64 grid-cols-1 place-content-start content-between overflow-hidden rounded-lg border border-solid border-neutral-80 bg-white px-4 py-5 text-left outline-none transition-all duration-100 hover:bg-neutral-100 hover:shadow focus:outline-none focus:ring-2 focus:ring-primary-40 focus:ring-offset-2 sm:p-6"
    :class="!disabled && 'cursor-pointer  hover:border-primary-40'"
    :disabled="disabled"
    @click="emitValue"
  >
    <div>
      <span
        :class="
          disabled
            ? 'bg-neutral-99 text-neutral-80'
            : 'bg-primary-95 text-primary-60 group-hover:bg-primary-60 group-hover:text-neutral-100 group-focus:bg-primary-60 group-focus:text-neutral-100'
        "
        class="inline-flex h-12 w-12 rounded-lg p-3 ring-0 transition-all duration-100"
      >
        <component :is="icon" class="h-6 w-6" aria-hidden="true" />
      </span>
    </div>
    <div v-if="disabled" class="absolute pl-8 pt-8">
      <span class="inline-flex h-6 w-6 rounded-full bg-primary-95 p-1 ring-0">
        <LockClosedIcon class="h-4 w-4 text-primary-60" />
      </span>
    </div>
    <div class="mt-4">
      <div class="text-lg font-medium leading-6 text-neutral-20" :class="!disabled && 'text-primary-60'">
        <span>{{ title }} </span>
      </div>
      <div class="mt-2 text-sm font-normal leading-5 text-neutral-40">
        <span>{{ description }}</span>
      </div>
    </div>
  </button>
</template>

<script setup lang="ts">
import type { Component } from "vue";
import { LockClosedIcon } from "@heroicons/vue/solid";

const props = withDefaults(
  defineProps<{
    title?: string;
    description?: string;
    disabled?: boolean;
    icon: Component;
  }>(),
  {
    title: "",
    description: "",
    disabled: false,
  },
);

// Emits
const emit = defineEmits<{
  (e: "click"): void;
}>();

const emitValue = () => {
  if (!props.disabled) emit("click");
};
</script>
